(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-hero"] && !Shopify.designMode) return;
  try {
    
  const faqItems = Array.from(document.querySelectorAll('.b2b-hero__item'));
  for (const item of faqItems) {
    const onClick = () => {
      item.classList.toggle('active');
    };
    item.addEventListener('click', onClick);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-6-products"] && !Shopify.designMode) return;
  try {
    
  // clears progress bar on first load - may get updated again from updateDiscountsSection()
// $(".progress-bar-inner").html('');

  $(document).ready(function() {
    var params = new URLSearchParams(window.location.search);
    var urlId = params.get('prid');

    if (urlId) {
      document.querySelectorAll('.tab-content').forEach((item) => {
        item.classList.remove('current');
      });

      document.querySelectorAll('.tab-link').forEach((item) => {
        item.classList.remove('current');
      });

      const activeTabContent = document.querySelector(`[data-url-id="${urlId}"]`);
      activeTabContent.classList.add('current');

      const activeTab = document.querySelector(`[data-tab="${
        activeTabContent.id
      }"]`);
      activeTab.classList.add('current');
    }
  });


/* * * * * * * * * *
   * HELPER FUNCTIONS *
   * * * *  * * * * * */
  function serializeEventData(event) {

// Get the form associated with this event
    var productForm = event.target.closest('form');
    var addToCart = productForm.querySelector('.btn--add-item');
    addToCart.disabled = false;
    addToCart.innerHTML = 'ADD TO CART';

// Serialize the form data using jQuery
    var serializedData = $(productForm).serialize();
    var params = new URLSearchParams(serializedData);

    if (! params.has('id')) {
      addToCart.disabled = true;
      addToCart.innerHTML = 'SOLD OUT';
    }
  }

  function updateCartCountInHeader(cart) {
    let cartCount = $('.cartcount');
    cartCount.html(cart.item_count);
  }


/* * * * * * * * **
   * MAIN TAB CHANGE *
   * * * * * * * * * */
  $('ul.tabs li').click(function() {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    var itemNumber = parseInt(tab_id.split('-')[1]);
    var productContainer = $('[data-item-number="' + itemNumber + '"]');
    const productForm = productContainer.find('.product__form');
    var serial = productForm.serialize();
    var params = new URLSearchParams(serial);
    if (! params.has('id')) {
      var addToCart = productForm.find('.btn--add-item');
      addToCart.prop('disabled', true);
      addToCart.html('SOLD OUT');
    }

    $(this).addClass('current');
    $('#' + tab_id).addClass('current');

// Reset product images slider after switching a tab
    let productSlider = $('#' + tab_id).find('.product__images-slider');
    if (productSlider.length) {
      productSlider.slick('setPosition');
    }
    document.querySelector(`#${tab_id}`) ?. querySelector('.form__list li .color_swatch li .color__swatch') ?. classList.add('active');
  });


/* * * * * * * * *
   * GO BACK BUTTON *
   * * * * * * * * **/
  $('.btn--bundle-prev').click(function(e) {
    e.preventDefault();
    const productContainer = $(this).closest('.tab-content');
    const itemNumber = parseInt(productContainer.data('item-number')) - 1;
    const prevTabLink = $('.tab-link-' + itemNumber);
    prevTabLink.click();
  });


/* * * **
   * FORMS *
   * * * * */
// Get all forms, listen to change event, pass to serializeEventData helper
  var forms = document.getElementsByClassName('product__form');
  for (var i = 0; i < forms.length; i++) {
    forms[i].addEventListener('change', (e) => {
      serializeEventData(e);
    });
  }


/* * * * *
   * COLORS *
   * * * * **/
// Get all color swatches, listen to click event, pass to serializeEventData helper
  var colorSelects = document.getElementsByClassName('colors__item');

  for (var i = 0; i < colorSelects.length; i++) {
    colorSelects[i].addEventListener('click', (e) => {
      serializeEventData(e);
    });
  }


/* * * * * * * * * * * **
   * CUSTOM COLOR SELECTOR *
   * * * * * * * * * * * * */
  $(document).click(function() {
    $('.bundle__builder .color__colors').hide();
  });

  $('.bundle__builder .color_select').click(function(e) {
    e.stopPropagation();
    $(this).next('.color__colors').toggle();
  });

  $('.bundle__builder .color__swatch-title').click(function() {
    $(this).siblings('.color__swatch').click();
  });

  $('.bundle__builder .colors__item').click(function() {
    const item = $(this).html();
    $(this).closest('.list__item').find('.color_select').html(item);
  });


/* * * * * *
   * ADD ITEM *
   * * * * * **/
// $('.btn--add-item').click(function (e) {
// e.preventDefault();
// const $this = $(this);
// const productContainer = $this.closest('.tab-content');
// const productForm = productContainer.find('.product__form');
// const itemNumber = productContainer.data('item-number');
// const productImage = productContainer.find('.product__images .images__featured').eq(1);
// const summaryItem = $('.bundle-item-' + itemNumber);
// const tabLink = $('.tab-link-' + itemNumber);

// $.ajax({
// url: '/cart/add.js',
// dataType: 'json',
// cache: false,
// type: 'post',
// data: productForm.serialize(),
// beforeSend: function beforeSend() {
// $this.find('[data-add-to-cart-text]').text('Adding...');
// },
// success: function success(product) {
// // avoid cart popup
// var removeCartVisible = setInterval(function () {
// if ($('#rebuy-cart.is-visible').length > 0) {
// clearInterval(removeCartVisible);
// Rebuy.SmartCart.hide();
// }
// }, 100);
// // empty slot
// if (!summaryItem.hasClass('has-item')) {
// summaryItem.addClass('has-item');
// // mobile quantity
// tabLink.addClass('has-item');
// }

// let currentQuantity = parseInt(tabLink.attr('data-quantity'));
// let quantityAdded = parseInt(productForm.find('input[name="quantity"]').val());
// summaryItem.find('.bundle-item-image-quantity').html(currentQuantity + quantityAdded);
// summaryItem.find('.bundle-item-image-container').append(productImage.clone());
// // mobile quantity
// tabLink.attr('data-quantity', currentQuantity + quantityAdded);

// let currentProducts = summaryItem.attr('data-items');
// let newProduct = product.id + ',' + quantityAdded;
// let newValue = currentProducts ? currentProducts + ';' + newProduct : newProduct;
// summaryItem.attr('data-items', newValue);

// // ATC button
// $this.find('[data-add-to-cart-text]').text('Added!');

// setTimeout(function () {
// $this.find('[data-add-to-cart-text]').text('ADD ANOTHER');
// $this.addClass('btn--border');
// const prodContainer = $this.closest('.tab-content');
// const itemNumber = parseInt(prodContainer.data('item-number')) + 1;
// const nextTabLink = $('.tab-link-' + itemNumber);
// nextTabLink.click();
// }, 2000);

// jQuery.getJSON('/cart.js', function (cart) {
// shippingModal(cart);
// updateDiscountsSection(cart);
// updateFreeShippingNote(cart);
// updateCartCountInHeader(cart);

// if (window.matchMedia('(max-width: 767px)').matches) {
// modalSetup.showModal();
// modalSetup.init();
// }
// });
// },
// error: function error(XMLHttpRequest) {
// $this.html('SOLD OUT');
// var response = eval('(' + XMLHttpRequest.responseText + ')');
// },
// });
// });

// /* * * * * * **
// * REMOVE ITEM *
// * * * * * * * */
// $('.bundle-item-image-remove').click(function () {
// let summaryItem = $(this).closest('.bundle-item');
// let items = summaryItem.attr('data-items').split(';');
// let item = items.pop();
// let itemID = item.split(',')[0];
// let itemQuantity = item.split(',')[1];

// const itemNumber = summaryItem.data('item-number');
// const tabLink = $('.tab-link-' + itemNumber);

// $.ajax({
// type: 'POST',
// url: '/cart/change.js',
// data: 'quantity=0&id=' + itemID,
// dataType: 'json',
// success: function success(cart) {
// // avoid cart popup
// var removeCartVisible = setInterval(function () {
// if ($('#rebuy-cart.is-visible').length > 0) {
// clearInterval(removeCartVisible);
// Rebuy.SmartCart.hide();
// }
// }, 100);

// summaryItem.find('.bundle-item-image-container img').last().remove();
// // check if not the last product
// if (items.length) {
// summaryItem.attr('data-items', items.join(';'));
// } else {
// summaryItem.removeClass('has-item').attr('data-items', '');
// tabLink.removeClass('has-item');
// }

// let currentQuantity = parseInt(tabLink.attr('data-quantity'));
// summaryItem.find('.bundle-item-image-quantity').html(currentQuantity - itemQuantity);
// // mobile quantity
// tabLink.attr('data-quantity', currentQuantity - itemQuantity);

// updateDiscountsSection(cart);
// updateFreeShippingNote(cart);
// updateCartCountInHeader(cart);
// },
// error: function error(XMLHttpRequest) {
// console.error(XMLHttpRequest);
// },
// });
// });


/* * * * * **
   * SHOW CART *
   * * * * * * */
// if (window.matchMedia('(max-width: 767px)').matches) {
// $('.bundle__builder-checkout a').attr('href', '/cart');
// }


/* * * * * * * *
   * CHANGE COUNT *
   * * * * * * * **/
// var xhttp = new XMLHttpRequest();
// var cur = '';
// xhttp.onreadystatechange = function() {
// if (this.readyState == 4 && this.status == 200) {
// var res = JSON.parse(xhttp.responseText);

// if (res.detected_values.country_name == 'Canada') {
// cur = 'CAD';
// } else {
// cur = 'USD';
// }

// var count = 1;
// var tab_count = 0;
// if (tab_count <= 3) {
// count++;
// var tabs = document.querySelectorAll('.tab-link');

// tabs.forEach(function(tab) {
// var current_tab = tab.dataset.tab;
// var tab_id = '#' + current_tab;
// var sp = $(tab_id).find('sale-price');
// var p = "";
// if (tab_id == '#tab-2') {
// p = "$105 " + cur;
// sp.html(p).attr('data-sale-price', p);
// }
// if (tab_id == '#tab-3') {
// p = "$140 " + cur;
// sp.html(p).attr('data-sale-price', p);
// }
// });
// }
// }
// };
// xhttp.open("GET", "/browsing_context_suggestions.json", true);
// xhttp.send();

// document.querySelectorAll('.tabs li').forEach(li=>li.addEventListener('click', function () {

// const tab_id = li.dataset.tab;
// document.querySelector(`#${tab_id}`)?.querySelector('.form__list li .color_swatch li .color__swatch')?.classList.add('active');
// }))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function loadBadge() {
    const imageSrc = 'https://benjilinens.myshopify.com/cdn/shop/t/231/assets/product-badge.png';

    const el = document.createElement('img');
    el.classList.add('product-badge-ca');
    el.src = imageSrc;

    const heroImage = document.getElementById('pwzrswiper-slide-0');
    heroImage.insertAdjacentElement('beforeend', el);
  }

  function debounce(func, time) {
    var time = time || 100; // 100 by default if no param
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, time, event);
    };
  }

  function handleWindowResizeForBadge() {
    document.querySelector('.product-badge-ca')?.remove();
    loadBadge();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const pathname = window.location.pathname;
    const pathnamesToLoadBadge = [
      '/products/sheet-sets',
      '/products/duvet-sets',
      '/products/comforter',
      '/products/pillow-sets',
    ];

    if (pathnamesToLoadBadge.includes(pathname)) {
      loadBadge();
      window.addEventListener('resize', debounce(handleWindowResizeForBadge, 150));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  function togglePlayButton() {
    // Select all elements with the .cs-picture class
    const pictures = document.querySelectorAll('.cs-video-wrapper');

    // Add a click event listener to each .cs-picture element
    pictures.forEach((picture) => {
      picture.addEventListener('click', () => {
        // Select all elements with the .cs-play class
        const playButton = picture.querySelector('.cs-play');

        // Toggle the .cs-hide class on each .cs-play element
        playButton.classList.toggle('cs-hide');
      });
    });
  }

  // Call the function to activate the event listeners
  togglePlayButton();

  function toggleVideoPlayback() {
    // Select the video element
    const videos = document.querySelectorAll('.cs-video-wrapper video');

    // Add a click event listener to the video
    videos.forEach((video) => {
      video.addEventListener('click', () => {
        // Check if the video is paused
        if (video.paused) {
          video.play(); // Play the video if it is paused
        } else {
          video.pause(); // Pause the video if it is playing
        }
      });
    });
  }

  // Call the function to activate the event listener
  toggleVideoPlayback();

  } catch(e) { console.error(e); }
})();
})();
